import React, { Component } from "react";
import { Link } from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

import Moment from 'moment';

function mydate(book_regdate) {
  var mntDate = new Moment(book_regdate);
  var strDisplayDate = mntDate.format('YYYY-MM-DD, h:mm:ss a');
  return strDisplayDate;
}


function mytime3(seconds) {
	var hour, min, sec;
	hour = parseInt(seconds/3600);
	min = parseInt((seconds%3600)/60);
	sec = parseInt(seconds%60);
	if (hour.toString().length === 1) hour = "0" + hour;
	if (min.toString().length === 1) min = "0" + min;
	if (sec.toString().length === 1) sec = "0" + sec;
	return hour + ":" + min + ":" + sec;
}

function mytime2(seconds) {
	var hour, min, sec;
	hour = parseInt(seconds/3600);
	min = parseInt((seconds%3600)/60);
	sec = parseInt(seconds%60);
	if (hour.toString().length === 1) hour = "0" + hour;
	if (min.toString().length === 1) min = "0" + min;
	if (sec.toString().length === 1) sec = "0" + sec;
	if(hour === 0) return min + ":" + sec;
	return hour + ":" + min + ":" + sec;
}


//var DEBUG52=true;
var DEBUG52=false;



class bookListDetail extends Component {

    constructor(props) {
        super(props);
        //this.state = { bl: [] };

        //alert(JSON.stringify(props));

        this.state = { totalcount: 0, booklist: [], loading: true };

        //alert(props.fetchurl);

        fetch(props.fetchurl)
			.then(response => response.json())
			.then(data => {
			    //this.setState({ forecasts: data, loading: false });
			    //alert(JSON.stringify(data));
			    //alert(data.totalcount);
			    this.state.totalcount = data.totalcount;
			    //this.state.loading = true;
			    //alert(this.state.totalcount);

			    this.setState({ totalcount: data.totalcount, booklist: data.lstresult, loading: false });
			});
    }

    dorender() {
        let bookDummy = this.state.booklist;

        //alert("1");

        return (
			bookDummy.map((book, index) => {
			    //if(DEBUG52) console.log("bookid: " + book.id);
				
			    let btnplay;
			    //if(DEBUG52) console.dir(book);
                if(book.ispreview !== undefined && book.ispreview === 1) {
                    btnplay= <a className="tag tag-audiobook" href={`mcbab://bookid/${book.refbookid}&${this.props.struserdbid}&1`} >미리듣기 <IconButton><PlayArrowIcon /></IconButton></a>;
                } else  {
			        btnplay= <a className="tag tag-audiobook" href={`mcbab://bookid/${book.refbookid}&${this.props.struserdbid}&0`} ><IconButton><PlayArrowIcon /></IconButton></a>;
                };

                let cont_play = "["+(book.curchapter+1)+"]. "+ mytime2(book.curduration)+" / "+mytime3(book.totalduration);

				if(book.totalduration<0.01) {
					cont_play="";
                } else {
                    cont_play= <span class="lendInfo-txt">이어 듣기 : {cont_play} </span>;
                    cont_play= <div className="bookList-lendInfo"> {cont_play} </div>;
                }

				return (
					<React.Fragment>
						<li className="bookList-item">
							<Link to={`/audiobook/${book.refbookid}`}>
								<div className="bookList-thumbnail">
									<div className="thumbnail">
										<img
											className="thumbnail-image"
											src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.refbookid}`}
											alt={book.subject}
										/>
									</div>
								</div>
								<div className="bookList-info">
									<h3 className="bookList-title">{book.subject}</h3>
									<h4 className="bookList-author">작가: {book.authorName}</h4>
									<h4 className="bookList-publisher">출판사: {book.publisherName}</h4>
									<div className="bookList-tag">
										<span className="tag tag-audiobook-kind">오디오북</span>
										<span className="tag tag-thebook-kind">더책</span>
									</div>
									<div className="bookList-lendInfo">
										<span class="lendInfo-txt">들은 일시 : {mydate(book.regdate)} </span>
									</div>
										 {cont_play} 
								</div>
							</Link>
							<div className="bookList-action">
								{btnplay}
							</div>
						</li>
					</React.Fragment>
				);
			})
		);
	}

	render() {

		let contents = this.state.loading === true
			? "Loading..."
			: this.dorender();

		return (
			<React.Fragment>
				<ul className="bookList">
					{contents}
				</ul>
			</React.Fragment>
		);
	}
}

export default bookListDetail;
